// @TODO Move this to standalone files in the future or when it starts to grow
export const MARKS = {
  // General
  APP_LOADED: 'app-loaded',
  APP_PROVIDERS_RENDERED: 'app-providers-rendered',
  APP_INITIALIZED: 'app-initialized',
  APP_RENDERED: 'app-rendered',
  APP_NG_RENDERED: 'app-ng-rendered',
  APP_ROUTE_AUTH: 'app-route-require-auth',
  APP_ROUTE_SITE_INITIALIZED: 'app-route-require-site',
  APP_ROUTE_SITE_RENDERED: 'app-route-require-site',

  // Recordings
  RECORDINGS_LIST_INITIALIZED: 'recordings-list-initialized',
  RECORDINGS_LIST_RENDERED: 'recordings-list-rendered',

  RECORDINGS_LIST_FETCH_DELAY: 'recordings-list-fetch-delay',
  RECORDINGS_LIST_FETCH_START: 'recordings-list-fetch-start',
  RECORDINGS_LIST_FETCH_TIME: 'recordings-list-fetch-time',

  RECORDINGS_LIST_SITE_FETCH_START: 'recordings-list-site-fetch-start',
  RECORDINGS_LIST_SITE_FETCH_TIME: 'recordings-list-site-fetch-time',

  RECORDINGS_LIST_USER_ATTRIBUTES_FETCH_START: 'recordings-list-user-attributes-fetch-start',
  RECORDINGS_LIST_USER_ATTRIBUTES_FETCH_TIME: 'recordings-list-user-attributes-fetch-time',

  RECORDINGS_LIST_SEGMENTS_FETCH_START: 'recordings-list-segments-fetch-start',
  RECORDINGS_LIST_SEGMENTS_FETCH_TIME: 'recordings-list-segments-fetch-time',

  // Playbacks
  PLAYBACKS_NEXT_RECORDING_FETCH_START: 'playbacks-next-recording-fetch-start',
  PLAYBACKS_RECORDING_LOADED: 'recording-loaded',
  PLAYBACKS_RECORDING_FIRST_TICK: 'started-watching-recording',

  // Highlights
  HIGHLIGHTS_LIST_INITIALIZED: 'highlights-list-initialized',
  HIGHLIGHTS_LIST_RENDER_TIME: 'highlights-list-render-time',

  RECORDING_HIGHLIGHT_CREATE_START: 'recording-highlight-create-start',
  RECORDING_HIGHLIGHT_CREATE_TIME: 'recordings-highlight-create-time',

  HEATMAP_HIGHLIGHT_CREATE_START: 'heatmap-highlight-create-start',
  HEATMAP_HIGHLIGHT_CREATE_TIME: 'heatmap-highlight-create-time',

  // Heatmaps
  HEATMAPS_VIEW_USER_ATTRS_START: 'heatmaps-view-attrs-start',
  HEATMAPS_VIEW_USER_ATTRS_TIME: 'heatmaps-view-attrs-time',

  HEATMAPS_DEFAULT_VIEW_INITIALIZED: 'heatmaps-default-view-initialized',
  HEATMAPS_DEFAULT_VIEW_RENDERED: 'heatmaps-default-view-rendered',

  HEATMAPS_REPORT_FETCH_START: 'heatmaps-report-fetch-start',
  HEATMAPS_REPORT_FETCH_TIME: 'heatmaps-report-fetch-time',

  HEATMAPS_SIDEBAR_FETCH_START: 'heatmaps-sidebar-fetch-start',
  HEATMAPS_SIDEBAR_FETCH_TIME: 'heatmaps-sidebar-fetch-time',

  // Sign up page
  SIGN_UP_PAGE_RENDERED: 'sign-up-page-rendered',

  SIGN_UP_PERSONAL_DETAILS_SUBMISSION_START: 'sign-up-personal-details-submission-start',
  SIGN_UP_PERSONAL_DETAILS_SUBMISSION_TIME: 'sign-up-personal-details-submission-time',

  SIGN_UP_VERIFY_EMAIL_SUBMISSION_START: 'sign-up-verify-email-submission-start',
  SIGN_UP_VERIFY_EMAIL_SUBMISSION_TIME: 'sign-up-verify-email-submission-time',

  SIGN_UP_ONBOARDING_SUBMISSION_START: 'sign-up-onboarding-submission-start',
  SIGN_UP_ONBOARDING_SUBMISSION_TIME: 'sign-up-onboarding-submission-time',

  SIGN_UP_WHERETO_INSTALL_SUBMISSION_START: 'sign-up-whereto-install-submission-start',
  SIGN_UP_WHERETO_INSTALL_SUBMISSION_TIME: 'sign-up-whereto-install-submission-time',

  SIGN_UP_DO_IT_LATER_SUBMISSION_START: 'sign-up-do-it-later-submission-start',
  SIGN_UP_DO_IT_LATER_SUBMISSION_TIME: 'sign-up-do-it-later-submission-time',

  // Workspaces
  WORKSPACES_CREATE_WORKSPACE_START: 'workspaces-create-workspace-start',
  WORKSPACES_CREATE_WORKSPACE_TIME: 'workspaces-create-workspace-time',
  WORKSPACES_USE_CURRENT_SPACE_START: 'workspaces-use-current-space-start',
  WORKSPACES_USE_CURRENT_SPACE_TIME: 'workspaces-use-current-space-time',
  WORKSPACES_LOAD_ACTIVE_WORKSPACES_LIST_START: 'workspaces-load-active-workspaces-list-start',
  WORKSPACES_LOAD_ACTIVE_WORKSPACES_LIST_TIME: 'workspaces-load-active-workspaces-list-time',
};
